<template>
	<form @submit.prevent>
		<div class="row">
			<UIShInputNumber
				v-bind="inputAttrs"
				label="Длина"
				v-model="lengthField.value.value"
				:error="lengthField.errorMessage.value"
			/>

			<UIShInputNumber
				v-bind="inputAttrs"
				label="Ширина"
				v-model="widthField.value.value"
				:error="widthField.errorMessage.value"
			/>

			<UIShInputNumber
				v-bind="inputAttrs"
				label="Высота"
				v-model="heightField.value.value"
				:error="heightField.errorMessage.value"
			/>
		</div>

		<div class="row">
			<UIShInputNumber
				v-bind="inputAttrs"
				label="Вес"
				v-model="weightField.value.value"
				:error="weightField.errorMessage.value"
				hint="кг"
			/>

			<UIShInputNumber
				v-bind="inputAttrs"
				label="Количество мест"
				v-model="countField.value.value"
				:error="countField.errorMessage.value"
				:hint="undefined"
			/>
		</div>
	</form>
</template>

<script setup lang="ts">
import type { ContainerData } from '@/common/types';

const inputAttrs = {
	min: 0,
	xl: 1920,
	lg: true,
	hint: 'мм',
	required: true
};

const model = defineModel<ContainerData>({ required: true });

const {
	countField,
	heightField,
	lengthField,
	weightField,
	widthField,
	validate
} = useCalcForm();

defineExpose({
	validate
});

watchEffect(() => {
	lengthField.setValue(model.value.length, false);
	widthField.setValue(model.value.width, false);
	heightField.setValue(model.value.height, false);
	weightField.setValue(model.value.weight, false);
	countField.setValue(model.value.count, false);
});

watchEffect(() => {
	model.value.length = lengthField.value.value;
	model.value.width = widthField.value.value;
	model.value.height = heightField.value.value;
	model.value.weight = weightField.value.value;
	model.value.count = countField.value.value;
});
</script>

<style lang="scss" scoped>
form {
	display: flex;
	flex-direction: column;
	gap: 0.889rem;
}

.row {
	display: flex;
	flex-direction: column;
	gap: 0.889rem;
	align-items: flex-start;

	& > * {
		width: 100%;
		flex: 1;
	}
}

@include screen1024 {
	.row {
		flex-direction: row;
		flex-wrap: nowrap;
		align-items: flex-start;
	}
}

@include screen1920 {
	form {
		gap: 1.111rem;
	}

	.row {
		gap: 1.111rem;
	}
}
</style>
